<script>
  export default {
    name: 'BaseRadioGroup',

    model: {
      prop: 'checked',
      event: 'change'
    },

    props: {
      checked: {
        default: null
      },
      name: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: Boolean,
        default: false
      }
    },

    render (createElement) {
      const defaultProps = {
        name: this.name,
        disabled: this.disabled,
        stacked: this.stacked
      }

      return createElement('div', { class: this.className, attrs: this.$attrs }, [
        this.$scopedSlots.default().map((slot, index) => {
          return this.$cloneNode(slot, {
            props: Object.assign({}, defaultProps, slot.componentOptions.propsData, { checked: this.checked }),
            on: {
              change: (checked) => this.$emit('change', checked)
            }
          })
        })
      ])
    }
  }
</script>
